export default __webpack_public_path__ + "static/media/logo.e51a6626.svg";